import { render, staticRenderFns } from "./WalkThrough.vue?vue&type=template&id=710ff8a4&scoped=true"
import script from "./WalkThrough.vue?vue&type=script&lang=js"
export * from "./WalkThrough.vue?vue&type=script&lang=js"
import style0 from "./WalkThrough.vue?vue&type=style&index=0&id=710ff8a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710ff8a4",
  null
  
)

export default component.exports